'use strict';

angular.module('ufcw')
  .controller('ReglasController', function ($rootScope) {
    $rootScope.headLander = false;

  });
